/*
 * NOTE: This function is a duplicate of the one in sharedImageViewer. If this
 * function changes the one in shared-image-viewer should change as well.
 */

import { i18n } from '@fs/zion-locale'
import { formatWithRules, joinDates } from './dateUtils'

export const dateFormats = {
  formatted: 'formatted',
  formattedFullWithTime: 'formattedFullWithTime',
  formattedCompactWithTime: 'formattedCompactWithTime',
  formattedCompactWithHourMinute: 'formattedCompactWithHourMinute',
  formattedMinimalWithTime: 'formattedMinimalWithTime',
}

export default function getFormattedDates(fromTimestamp = null, toTimestamp = null, dateFormat = null) {
  let goodFormatFromTimestamp = fromTimestamp
  let goodFormatToTimestamp = toTimestamp
  if (fromTimestamp && typeof fromTimestamp === 'string' && /^\d{2}-\d{2}-\d{4}$/.exec(fromTimestamp)) {
    // Date string format not supported by Safari
    const [month, date, year] = fromTimestamp.split('-')
    goodFormatFromTimestamp = `${year}/${month}/${date}`
  }
  if (toTimestamp && typeof toTimestamp === 'string' && /^\d{2}-\d{2}-\d{4}$/.exec(toTimestamp)) {
    // Date string format not supported by Safari
    const [month, date, year] = toTimestamp.split('-')
    goodFormatToTimestamp = `${year}/${month}/${date}`
  }
  // check if dates are nullish instead of falsy so timestamp 0 can be used
  const fromISOString = goodFormatFromTimestamp !== null ? new Date(goodFormatFromTimestamp).toISOString() : null
  const toISOString = goodFormatToTimestamp !== null ? new Date(goodFormatToTimestamp).toISOString() : null
  const fromDate = goodFormatFromTimestamp ? new Date(goodFormatFromTimestamp) : null
  const toDate = goodFormatToTimestamp ? new Date(goodFormatToTimestamp) : null
  const locale = i18n.language

  if (dateFormat === 'formatted') return formatWithRules({ fromISOString, toISOString, locale })

  const formatMap = {
    formattedFullWithTime: 'FULL_WITH_TIME',
    formattedCompactWithTime: 'COMPACT_WITH_TIME',
    formattedCompactWithHourMinute: 'COMPACT_WITH_HOUR_MINUTE',
    formattedMinimalWithTime: 'MINIMAL_WITH_TIME',
  }
  const format = formatMap?.[dateFormat]
  if (!format) throw new Error(`The date format ${dateFormat} does not exist`)

  return joinDates({ fromDate, toDate, format, locale })
}
